<template>
  <b-card no-body class="classification-card">
    <b-card-header class="classification-header">
      <div class="header-title">
        <i class="fas fa-tags mr-2"></i>
        <strong>Classificação</strong>
      </div>
      <div class="header-actions">
        <b-button
          v-if="canEdit"
          variant="primary"
          size="sm"
          @click="$emit('open')"
        >
          <i class="fas fa-edit mr-1"></i>
          Editar
        </b-button>
      </div>
    </b-card-header>
    <b-card-body class="classification-body">
      <template v-if="ombudsman.classification">
        <ClassificationViewer
          :record="ombudsman"
          classification="receivingMeans"
          label="Recebimento"
        />
        <ClassificationViewer
          :record="ombudsman"
          classification="ombudsmanNature"
          label="Natureza da Comunicação"
        />
        <ClassificationViewer
          :record="ombudsman"
          classification="involvedDepartment"
          label="Área Reclamada"
        />
        <ClassificationViewer
          :record="ombudsman"
          classification="ombudsmanService"
          label="Serviço Reclamado"
        />
        <ClassificationViewer
          :record="ombudsman"
          classification="businessUnit"
          label="Unidade Reclamada"
        />
        <ClassificationViewer
          :record="ombudsman"
          classification="ombudsmanSegment"
          label="Segmento do Cliente"
        />
        <ClassificationViewer
          v-for="group in classificationGroups"
          :key="group._id"
          :record="ombudsman"
          :classification="`custom_${group._id}`"
          :label="group.name"
          type="ombudsman"
        />
      </template>
      <div v-else class="no-classification">
        <i class="fas fa-tags fa-2x text-muted"></i>
        <p class="mt-2 text-muted">Nenhuma classificação definida</p>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import ClassificationViewer from "@/views/commons/ClassificationViewer";

export default {
  name: "ClassificationCard",
  components: {
    ClassificationViewer,
  },
  props: {
    ombudsman: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    classificationGroups: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
